import { createEnv } from '@t3-oss/env-nextjs';
import { z } from 'zod';

export const keys = () =>
  createEnv({
    client: {
      // Boutique Plan
      NEXT_PUBLIC_BILLING_PRICE_BOUTIQUE_MONTH_ID: z.string().optional(),
      NEXT_PUBLIC_BILLING_PRICE_BOUTIQUE_YEAR_ID: z.string().optional(),
      // Marketplace Plan
      NEXT_PUBLIC_BILLING_PRICE_MARKETPLACE_MONTH_ID: z.string().optional(),
      NEXT_PUBLIC_BILLING_PRICE_MARKETPLACE_YEAR_ID: z.string().optional(),
      // Enterprise Plan
      // Credit Top-ups
      NEXT_PUBLIC_BILLING_PRICE_CREDITS_10_ID: z.string().optional(),
      NEXT_PUBLIC_BILLING_PRICE_CREDITS_35_ID: z.string().optional(),
      NEXT_PUBLIC_BILLING_PRICE_CREDITS_65_ID: z.string().optional()
    },
    server: {
      BILLING_STRIPE_SECRET_KEY: z.string().optional(),
      BILLING_STRIPE_WEBHOOK_SECRET: z.string().optional()
    },
    runtimeEnv: {
      // Boutique Plan
      NEXT_PUBLIC_BILLING_PRICE_BOUTIQUE_MONTH_ID:
        process.env.NEXT_PUBLIC_BILLING_PRICE_BOUTIQUE_MONTH_ID,
      NEXT_PUBLIC_BILLING_PRICE_BOUTIQUE_YEAR_ID:
        process.env.NEXT_PUBLIC_BILLING_PRICE_BOUTIQUE_YEAR_ID,
      // Marketplace Plan
      NEXT_PUBLIC_BILLING_PRICE_MARKETPLACE_MONTH_ID:
        process.env.NEXT_PUBLIC_BILLING_PRICE_MARKETPLACE_MONTH_ID,
      NEXT_PUBLIC_BILLING_PRICE_MARKETPLACE_YEAR_ID:
        process.env.NEXT_PUBLIC_BILLING_PRICE_MARKETPLACE_YEAR_ID,
      // Credit Top-ups
      NEXT_PUBLIC_BILLING_PRICE_CREDITS_10_ID:
        process.env.NEXT_PUBLIC_BILLING_PRICE_CREDITS_10_ID,
      NEXT_PUBLIC_BILLING_PRICE_CREDITS_35_ID:
        process.env.NEXT_PUBLIC_BILLING_PRICE_CREDITS_35_ID,
      NEXT_PUBLIC_BILLING_PRICE_CREDITS_65_ID:
        process.env.NEXT_PUBLIC_BILLING_PRICE_CREDITS_65_ID,
      // Stripe Configuration
      BILLING_STRIPE_SECRET_KEY: process.env.BILLING_STRIPE_SECRET_KEY,
      BILLING_STRIPE_WEBHOOK_SECRET: process.env.BILLING_STRIPE_WEBHOOK_SECRET
    }
  });
